/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perm_Product_Leveling_Adjust_WriteInputs */



/**
* | output |
* | --- |
* | "Adjust members’ XP" |
*
* @param {Perm_Product_Leveling_Adjust_WriteInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perm_product_leveling_adjust_write = /** @type {((inputs?: Perm_Product_Leveling_Adjust_WriteInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perm_Product_Leveling_Adjust_WriteInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Менять XP участников")
	return /** @type {LocalizedString} */ ("Adjust members’ XP")
});